import React from "react";
import Turntable_Activity_details_rules from "./Turntable_Activity_details_rules/Turntable_Activity_details_rules";
import Turntable_Activity_details_table from "./Turntable_Activity_details_table/Turntable_Activity_details_table";
import Common_white_header from "../../Common/Common_Component/Common_white_header/Common_white_header";

function Turntable_Activity_details() {
  return (
    <>
      <section className="Turntable_Activity_details">
        <Common_white_header headingText={"Activity details"} />
        <div className="container">
          <Turntable_Activity_details_table />
          <Turntable_Activity_details_rules />
        </div>
      </section>
    </>
  );
}

export default Turntable_Activity_details;
